import { useEffect, useState, useRef } from "react"
import { Link, useLocation } from "react-router-dom"
import { createOverlay, removeOverlay } from "../overlay"
import { useCart } from "../../contexts/CartContext"
import { fetchProductList } from "../../api/Product"
import { Product } from "../../api/ProductType"
import { getUserPoints, UserPointData } from "../../api/points"
import { useSetting } from "../../contexts/SettingContext"

const keywords = [
  "Tìm kiếm thuốc, hoạt chất, nhà bán hàng...",
]

export default function Header({ onOpenMenu }: { onOpenMenu: () => void }) {
  const { totalItems } = useCart();
  const { settings: appSettings } = useSetting();
  const { pathname } = useLocation();
  const inputRef = useRef<HTMLInputElement>(null)
  const [activeIndex, setActiveIndex] = useState(0)
  const [searchOpen, setSearchOpen] = useState(false)
  const [profileOpen, setProfileOpen] = useState(false)
  const [user, setUser] = useState<any>(null)
  const [searchQuery, setSearchQuery] = useState("")
  const [searchResults, setSearchResults] = useState<Product[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [recentSearches, setRecentSearches] = useState<string[]>([])
  const [pointData, setPointData] = useState<UserPointData | null>(null)

  const getUserInitials = (fullname?: string) => {
    const parts = (fullname || "").trim().split(/\s+/).filter(Boolean)
    if (parts.length === 0) return "?"

    const first = parts[0].charAt(0)
    const last = parts[parts.length - 1].charAt(0)
    return `${first}${last}`.toUpperCase()
  }

  const getLevelIcon = (level: string) => {
    const levelKey = level.toLowerCase()

    if (levelKey.includes("gold")) {
      return "https://cdn-web-next.thuocsi.vn/images/level_new/gold_new.svg"
    }
    if (levelKey.includes("diamond")) {
      return "https://cdn-web-next.thuocsi.vn/images/level_new/diamond_new.svg"
    }
    if (levelKey.includes("platinum")) {
      return "https://cdn-web-next.thuocsi.vn/images/level_new/platinum_new.svg"
    }

    return "https://cdn-web-next.thuocsi.vn/images/level_new/sliver_new.svg"
  }

  useEffect(() => {
    const storedRecent = localStorage.getItem('recentSearches')
    if (storedRecent) {
      try {
        setRecentSearches(JSON.parse(storedRecent))
      } catch (e) {
        console.error("Failed to parse recent searches", e)
      }
    }
  }, [])

  const handleSaveRecentSearch = (keyword: string) => {
    if (!keyword.trim()) return
    const currentRecent = recentSearches.filter(k => k !== keyword)
    const newRecent = [keyword, ...currentRecent].slice(0, 5)
    setRecentSearches(newRecent)
    localStorage.setItem('recentSearches', JSON.stringify(newRecent))
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchQuery.trim()) {
        setIsLoading(true);
        try {
          const params = {
            name: searchQuery,
            limit: 5
          };
          const response = await fetchProductList(params);
          if (response && response.data && response.data.items) {
            setSearchResults(response.data.items);
          } else {
            setSearchResults([]);
          }
        } catch (error) {
          console.error("Search error", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setSearchResults([])
      }
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchQuery])

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % keywords.length)
    }, 2000)

    return () => clearInterval(timer)
  }, [])

  const overlayOpen = searchOpen || profileOpen

  useEffect(() => {
    setSearchOpen(false)
    setProfileOpen(false)
  }, [pathname])

  useEffect(() => {
    if (overlayOpen) {
      createOverlay(() => {
        setSearchOpen(false)
        setProfileOpen(false)
      })
    } else {
      removeOverlay()
    }
  }, [overlayOpen])

  useEffect(() => {
    const customerInfo = localStorage.getItem('user')
    if (customerInfo) {
      setUser(JSON.parse(customerInfo))
    }
  }, [])

  useEffect(() => {
    const loadUserPoints = async () => {
      try {
        const response = await getUserPoints()
        if (response?.status && response.data) {
          setPointData(response.data)
        }
      } catch (error) {
        console.error("Failed to load user points", error)
      }
    }

    loadUserPoints()
  }, [])

  const currentLevel = (pointData?.level || "New").trim()
  const pointBalance = Number(pointData?.point_balance || 0)

  return (
    <>
      <div className="styles_stickyHeaderSearch__TZM5L hidden-1199 bg-gradient">
        <div className="MuiContainer-root styles_headerCenter_wrapper__ibONV MuiContainer-maxWidthLg !h-full !items-start !py-2">
          <Link
            className="styles_mobile_rootBase__8z7PQ"
            to="/"
            id="logo-thuocsi"
            title="Tra cứu và đặt thuốc giá sỉ nhanh tại thuocsi.vn"
            style={{ padding: '0px' }}
          >
            <div className="styles_logo__185XE MuiBox-root css-0"
              style={{
                border: '0px',
                margin: '0px',
                padding: '0px',
              }}
            >
              <span
                style={{
                  boxSizing: 'border-box',
                  display: 'inline-block',
                  overflow: 'hidden',
                  width: '68px',
                  height: '68px',
                  background: 'none',
                  opacity: 1,
                  border: '0px',
                  margin: '0px',
                  padding: '0px',
                  position: 'relative',
                }}
              ><img
                  alt="Tra cứu và đặt thuốc giá sỉ nhanh tại thuocsi.vn"
                  title="Tra cứu và đặt thuốc giá sỉ nhanh tại thuocsi.vn"
                  data-origin-url={appSettings.logo}
                  src={appSettings.logo || undefined}
                  decoding="async"
                  data-nimg="fixed"
                  style={{
                    visibility: appSettings.logo ? 'visible' : 'hidden',
                    position: 'absolute',
                    inset: '0px',
                    boxSizing: 'border-box',
                    padding: '0px',
                    border: 'none',
                    margin: 'auto',
                    display: 'block',
                    width: '0px',
                    height: '0px',
                    minWidth: '100%',
                    maxWidth: '100%',
                    minHeight: '100%',
                    maxHeight: '100%',
                  }} /><noscript></noscript
                  ></span></div
            ></Link>
          <div id="search__homepage" className="styles_searchBar__IODZZ">
            <div className="styles_search_wrap__HLrm2 MuiBox-root css-0">
              <div className="styles_searchContainer__bowJ2">
                <div
                  className="MuiFormControl-root MuiTextField-root styles_root_input__4ABPe styles_SearchInput__G_RwG w-100-130px"
                >
                  <div
                    className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl MuiInputBase-adornedStart"
                  >
                    <div className="MuiInputAdornment-root MuiInputAdornment-positionStart">
                      <span
                        style={{
                          boxSizing: 'border-box',
                          display: 'inline-block',
                          overflow: 'hidden',
                          width: 'initial',
                          height: 'initial',
                          background: 'none',
                          opacity: 1,
                          border: '0px',
                          margin: '0px',
                          padding: '0px',
                          position: 'relative',
                          maxWidth: '100%',
                        }}
                      ><span
                        style={{
                          boxSizing: 'border-box',
                          display: 'block',
                          width: 'initial',
                          height: 'initial',
                          background: 'none',
                          opacity: 1,
                          border: '0px',
                          margin: '0px',
                          padding: '0px',
                          maxWidth: '100%',
                        }}
                      ><img
                            alt=""
                            aria-hidden="true"
                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2720%27%20height=%2720%27/%3e"
                            style={{
                              display: 'block',
                              maxWidth: '100%',
                              width: 'initial',
                              height: 'initial',
                              background: 'none',
                              opacity: 1,
                              border: '0px',
                              margin: '0px',
                              padding: '0px',
                            }} /></span
                        ><img
                          data-origin-url="https://cdn-web-next.thuocsi.vn/images/header-v2/Search_icon.svg"
                          src="https://cdn-web-next.thuocsi.vn/images/header-v2/Search_icon.svg"
                          decoding="async"
                          data-nimg="intrinsic"
                          alt="Search"
                          style={{
                            position: 'absolute',
                            inset: '0px',
                            boxSizing: 'border-box',
                            padding: '0px',
                            border: 'none',
                            margin: 'auto',
                            display: 'block',
                            width: '0px',
                            height: '0px',
                            minWidth: '100%',
                            maxWidth: '100%',
                            minHeight: '100%',
                            maxHeight: '100%',
                          }} /><noscript></noscript
                          ></span>
                    </div>
                    <input
                      ref={inputRef}
                      onFocus={() => {
                        console.log("FOCUS INPUT")
                        setProfileOpen(false)
                        setSearchOpen(true)
                      }}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      value={searchQuery}
                      onClick={(e) => e.stopPropagation()}
                      type="search"
                      className="MuiInputBase-input MuiInput-input MuiInputBase-inputAdornedStart MuiInputBase-inputTypeSearch MuiInput-inputTypeSearch"
                    />
                  </div>
                </div>
                {
                  !searchQuery && (
                    <div
                      className="styles_placeholder_wrapper__Y944P"
                      role="button"
                    >
                      {keywords.map((text, index) => {
                        const isActive = index === activeIndex

                        return (
                          <div
                            key={index}
                            className="styles_placeholder__v2N9g suggest_keyword"
                            style={{
                              opacity: isActive ? 1 : 0,
                              transform: isActive
                                ? "translateY(90%)"
                                : "translateY(150%)",
                            }}
                          >
                            <span>{text}</span>
                          </div>
                        )
                      })}
                    </div>
                  )
                }
                <div className="styles_selectSearch__VtsX7">
                  <div className="MuiFormControl-root styles_formControl__utyhi">
                    <span className="styles_customHr__2wCvq"></span>
                    <div
                      className="MuiInputBase-root MuiInput-root MuiInput-underline styles_selectInput__T0khH MuiInputBase-formControl MuiInput-formControl"
                    >
                      <select
                        className="MuiNativeSelect-root MuiNativeSelect-select MuiInputBase-input MuiInput-input"
                        aria-invalid={false}
                        id="search-type"
                        name="search"
                      >
                        <option value="1" style={{ cursor: 'pointer', color: 'rgb(0, 0, 0)' }}>Thuốc &amp; Hoạt Chất</option>
                        {/* <option value="4" style={{ cursor: 'pointer', color: 'rgb(0, 0, 0)' }}>Thuốc</option>
                        <option value="2" style={{ cursor: 'pointer', color: 'rgb(0, 0, 0)' }}>Hoạt Chất</option>
                        <option value="3" style={{ cursor: 'pointer', color: 'rgb(0, 0, 0)' }}>Nhà Bán Hàng</option> */}
                      </select
                      ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12.9182 16.006C12.4233 16.5418 11.5768 16.5418 11.0818 16.006L7.01006 11.5982C6.2705 10.7976 6.83834 9.5 7.92825 9.5H16.0718C17.1617 9.5 17.7296 10.7976 16.99 11.5982L12.9182 16.006Z"
                          fill="#555555"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              {searchOpen && (
                <div className="styles_searchDropdown___Jm9a MuiBox-root css-0">
                  {/* Scroll container */}
                  <div className="styles_styledScroll__Fxtup MuiBox-root css-0" />

                  {searchQuery ? (
                    <div className="MuiBox-root css-0" style={{ padding: '10px' }}>
                      {isLoading ? (
                        <div style={{ padding: '10px', textAlign: 'center' }}>Đang tìm kiếm...</div>
                      ) : searchResults.length > 0 ? (
                        searchResults.map((product) => (
                          <Link
                            key={product.id}
                            to={`/product/${product.slug}`}
                            className="styles_hoveredRecentSearchText__i5Wqf"
                            style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', textDecoration: 'none', color: 'inherit' }}
                            onClick={() => handleSaveRecentSearch(searchQuery)}
                          >
                            <img src={product.avatar} alt={product.name} style={{ width: '40px', height: '40px', objectFit: 'contain', border: '1px solid #eee', borderRadius: '4px' }} />
                            <div>
                              <div style={{ fontWeight: '500' }}>{product.name}</div>
                              <div style={{ fontSize: '14px', color: '#428c04', fontWeight: 'bold' }}>{product.price?.toLocaleString('vi-VN')} đ</div>
                            </div>
                          </Link>
                        ))
                      ) : (
                        <div style={{ padding: '10px', textAlign: 'center' }}>Không tìm thấy sản phẩm</div>
                      )}
                    </div>
                  ) : (
                    <>
                      {/* Recent search */}
                      {recentSearches.length > 0 && (
                        <div className="MuiBox-root css-0">
                          <div className="styles_recentSearchTextContainer__GQbeo">
                            <span
                              style={{
                                boxSizing: "border-box",
                                display: "inline-block",
                                overflow: "hidden",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: 0,
                                margin: 0,
                                padding: 0,
                                position: "relative",
                                maxWidth: "100%",
                              }}
                            >
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  display: "block",
                                  width: "initial",
                                  height: "initial",
                                  background: "none",
                                  opacity: 1,
                                  border: 0,
                                  margin: 0,
                                  padding: 0,
                                  maxWidth: "100%",
                                }}
                              >
                                <img
                                  alt=""
                                  aria-hidden="true"
                                  src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e"
                                  style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                  }}
                                />
                              </span>

                              <img
                                src="https://cdn-web-next.thuocsi.vn/icons/history_clock.svg"
                                decoding="async"
                                data-nimg="intrinsic"
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  boxSizing: "border-box",
                                  padding: 0,
                                  border: "none",
                                  margin: "auto",
                                  display: "block",
                                  width: 0,
                                  height: 0,
                                  minWidth: "100%",
                                  maxWidth: "100%",
                                  minHeight: "100%",
                                  maxHeight: "100%",
                                }}
                              />
                            </span>

                            <span className="styles_recentSearchTextContent__gi1Jl">
                              Lịch sử tìm kiếm
                            </span>
                          </div>

                          {/* Recent search items */}
                          {recentSearches.map((text, index) => (
                            <div
                              key={index}
                              className="styles_hoveredRecentSearchText__i5Wqf"
                              role="button"
                              onClick={() => setSearchQuery(text)}
                            >
                              {text}
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Most searching */}
                      {/* <div className="styles_mostSearching__Dg1XV">
                        <div className="styles_label__MQGtX MuiBox-root css-6n7j50">
                          <p
                            className="MuiTypography-root MuiTypography-body1 MuiTypography-displayInline"
                            style={{ fontWeight: 500, fontSize: 14 }}
                          >
                            Tìm kiếm nhiều nhất
                          </p>
                        </div>

                        <div className="styles_results__eK7hJ MuiBox-root css-0">
                          <a
                            className="styles_mobile_rootBase__8z7PQ styles_tag__p1F53"
                            href="/products?tag=CA15.12&utm_source=website&utm_medium=topsearch&utm_campaign=b_CAT&utm_term=202512&utm_content=b_CAT"
                          >
                            <div className="styles_dot__tt_Qd" />
                            <span className="styles_hashtag__UR_9Q">
                              Ưu Đãi Khủng Tới 20%
                            </span>
                          </a>

                          <a
                            className="styles_mobile_rootBase__8z7PQ styles_tag__p1F53"
                            href="/products?tag=MYLY&utm_source=website&utm_medium=topsearch&utm_campaign=b_Mayoly&utm_term=202512&utm_content=b_Mayoly"
                          >
                            <div className="styles_dot__tt_Qd" />
                            <span className="styles_hashtag__UR_9Q">
                              Mayoly Giảm Tới 8K
                            </span>
                          </a>

                          <a
                            className="styles_mobile_rootBase__8z7PQ styles_tag__p1F53"
                            href="/flagship-store/sanofi-viet-nam/list-product?utm_source=website&utm_medium=topsearch&utm_campaign=b_Opella&utm_term=202512&utm_content=b_Opella"
                          >
                            <div className="styles_dot__tt_Qd" />
                            <span className="styles_hashtag__UR_9Q">
                              Quà Tặng &amp; Voucher 10%
                            </span>
                          </a>

                          <a
                            className="styles_mobile_rootBase__8z7PQ styles_tag__p1F53"
                            href="/promo-codes/DEC25_DAILY15_3?utm_source=website&utm_medium=topsearch&utm_campaign=camp_salekhungcuoinam&utm_term=202512&utm_content=0"
                          >
                            <div className="styles_dot__tt_Qd" />
                            <span className="styles_hashtag__UR_9Q">
                              Giảm Ngay 15K
                            </span>
                          </a>

                          <a
                            className="styles_mobile_rootBase__8z7PQ styles_tag__p1F53"
                            href="/products?tag=B4DX&utm_source=website&utm_medium=topsearch&utm_campaign=camp_salekhungcuoinam&utm_term=202512&utm_content=0"
                          >
                            <div className="styles_dot__tt_Qd" />
                            <span className="styles_hashtag__UR_9Q">
                              Tặng Ổ Cắm Điện Quang
                            </span>
                          </a>

                          <a
                            className="styles_mobile_rootBase__8z7PQ styles_tag__p1F53"
                            href="/products?tag=7U2U&utm_source=website&utm_medium=topsearch&utm_campaign=b_ownbrand&utm_term=202512&utm_content=b_ownbrand"
                          >
                            <div className="styles_dot__tt_Qd" />
                            <span className="styles_hashtag__UR_9Q">
                              Ưu Đãi Đến 500K
                            </span>
                          </a>
                        </div>
                      </div> */}
                    </>
                  )}
                </div>
              )}
            </div>

          </div>
          <div className="styles_headerIconLogged__QrNnI MuiBox-root css-0">
            <div className="styles_headerStatus__0lZR5 MuiBox-root css-0">
              <div id="cart__icon" className="styles_cartContainer__0sVOi">
                <Link className="styles_mobile_rootBase__8z7PQ styles_cartLink__6kL_q" to="/cart"
                ><div className="styles_cart__kVp3U">
                    <div className="styles_badgeContainer__krkFJ">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="#428c04">
                        <path
                          d="M16.3943 2.4H3.74199L2.66095 0.369213C2.53961 0.141267 2.31006 0 2.061 0H0.687001C0.307581 0 0 0.322355 0 0.72C0 1.11765 0.307581 1.44 0.687001 1.44H1.65759L2.72446 3.44415L5.1849 9.14964L5.18742 9.15547L5.40414 9.658L2.93383 12.4196C2.7562 12.6181 2.7006 12.9047 2.79013 13.1602C2.87965 13.4157 3.09899 13.5964 3.35701 13.6273L5.60867 13.897C8.42507 14.2344 11.269 14.2344 14.0854 13.897L16.337 13.6273C16.714 13.5822 16.9847 13.2253 16.9416 12.8302C16.8985 12.4352 16.558 12.1515 16.181 12.1967L13.9294 12.4664C11.2166 12.7913 8.47741 12.7913 5.76468 12.4664L4.8711 12.3593L6.68422 10.3324C6.70175 10.3128 6.71804 10.2925 6.73308 10.2715L7.42266 10.3655C8.38897 10.4973 9.36576 10.5231 10.3372 10.4426C12.6029 10.2548 14.7027 9.12488 16.1688 7.30471L16.6983 6.64728C16.7161 6.6252 16.7326 6.60202 16.7477 6.57787L17.7346 5.00169C18.4341 3.88447 17.6694 2.4 16.3943 2.4Z"
                          fill="#428c04"
                        ></path>
                        <path
                          d="M4.80901 15.12C4.05017 15.12 3.435 15.7647 3.435 16.56C3.435 17.3553 4.05017 18 4.80901 18C5.56785 18 6.18301 17.3553 6.18301 16.56C6.18301 15.7647 5.56785 15.12 4.80901 15.12Z"
                          fill="#428c04"
                        ></path>
                        <path
                          d="M13.511 16.56C13.511 15.7647 14.1262 15.12 14.885 15.12C15.6439 15.12 16.259 15.7647 16.259 16.56C16.259 17.3553 15.6439 18 14.885 18C14.1262 18 13.511 17.3553 13.511 16.56Z"
                          fill="#428c04"
                        ></path></svg
                      ><span className="styles_badge__9thnG">{totalItems}</span>
                    </div>
                    Giỏ Hàng
                  </div></Link
                >
              </div>
            </div>
            <div className="styles_profile__MKk3m MuiBox-root css-0 !ml-[15px]">
              <div id="profile__guide" className="styles_borderRadius__Q_n1v">
                <div className="styles_wrapperProfile__nQGUN">
                  <Link
                    className="styles_mobile_rootBase__8z7PQ"
                    to="/my-account" style={{ padding: '0px' }}
                  >
                    <div className="styles_avatar__QQJbp MuiBox-root css-0">
                      <span
                        style={{
                          boxSizing: 'border-box',
                          display: 'inline-block',
                          overflow: 'hidden',
                          width: '36px',
                          height: '36px',
                          background: 'none',
                          opacity: 1,
                          border: '0px',
                          margin: '0px',
                          padding: '0px',
                          position: 'relative',
                        }}
                      >
                        {
                          user?.avatar ? (
                            <img
                              data-origin-url="https://storage.googleapis.com/thuocsi-live/images/2025d1ee085126dbc1346a31d7630126"
                              src={user?.avatar || ""}

                              decoding="async"
                              data-nimg="fixed"
                              alt="Profile"
                              style={{
                                position: 'absolute',
                                inset: '0px',
                                boxSizing: 'border-box',
                                padding: '0px',
                                border: 'none',
                                margin: 'auto',
                                display: 'block',
                                width: '0px',
                                height: '0px',
                                minWidth: '100%',
                                maxWidth: '100%',
                                minHeight: '100%',
                                maxHeight: '100%',
                              }} />
                          ) : (
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                height: '100%',
                                backgroundColor: '#eee',
                                color: '#555',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                              }}
                            >
                              {getUserInitials(user?.fullname)}
                            </span>
                          )}
                      </span>
                    </div>
                  </Link>
                  <div className="styles_profile_name__11tu9 MuiBox-root css-0">
                    <p className="MuiTypography-root MuiTypography-body1 !text-white !text-[14px]">{user?.fullname}</p>
                  </div>
                  <div className="styles_profileContainer__mXrKq MuiBox-root css-0">
                    <button
                      className="MuiButtonBase-root MuiIconButton-root styles_iconInfo__4tIMU"
                      tabIndex={0} type="button"
                      onClick={(e) => {
                        e.stopPropagation()
                        setSearchOpen(false)
                        setProfileOpen(true)
                      }}
                    >
                      <span className="MuiIconButton-label"
                      ><svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg></span
                      ><span className="MuiTouchRipple-root"></span>
                    </button>
                    {profileOpen && (
                      <div className="styles_profilePopup__kmf_N">
                        {/* Wishlist */}
                        <div className="styles_wishListContainer__1EJmY">
                          <span className="styles_wishListTitle__xc0uJ">
                            <span className="styles_textTitle__zk4mU">
                              <span>
                                <img
                                  alt="Trái tim"
                                  src="https://cdn-web-next.thuocsi.vn/images/level_new/heart.svg"
                                />
                              </span>
                              Sản phẩm quan tâm
                            </span>

                            <button
                              className="MuiButtonBase-root styles_buttonBase__zNndN"
                              type="button"
                            >
                              Xem thêm
                              <span>
                                <img
                                  alt="Mũi tên"
                                  src="https://cdn-web-next.thuocsi.vn/images/level_new/arrow.svg"
                                />
                              </span>
                            </button>
                          </span>

                          <div className="styles_wishListContent__f4dPT">
                            <div className="styles_renderWishList__s7sHq">
                              <div className="styles_emptyContainer__ogwgU">
                                <img
                                  alt="guide"
                                  src="https://cdn-web-next.thuocsi.vn/images/level_new/guide.png"
                                />

                                <div className="styles_wrapperHereGif__AutGe">
                                  <img
                                    alt="here"
                                    src="https://cdn-web-next.thuocsi.vn/images/level_new/here.gif"
                                  />
                                </div>

                                <span className="styles_textGuide__gcz76">
                                  Hãy nhấn vào biểu tượng{" "}
                                  <span className="styles_boldText__940y9">“Trái tim”</span> trên thẻ
                                  sản phẩm để thêm sản phẩm quan tâm bạn nhé
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Menu */}
                        <div className="styles_menuListContainer__Rsl7M">
                          <div className="styles_levelContainer__P3_xx">
                            <div className="styles_levelIcon__TZCC4">
                              <span className="styles_leftContent__M_Hm6">
                                Cấp bậc
                                <img
                                  alt={currentLevel}
                                  src={pointData?.level_avatar}
                                />
                              </span>

                              <span className="styles_customHr__qtDq_" />

                              <span className="styles_rightContent__9EvAr">
                                Điểm tích lũy
                                <span className="styles_score__WtCxP">
                                  <img
                                    alt="Huy chương"
                                    src="https://cdn-web-next.thuocsi.vn/images/level_new/reward.svg"
                                  />
                                  {pointBalance.toLocaleString("vi-VN")}
                                </span>
                              </span>
                            </div>
                          </div>

                          <div className="styles_menuContainer__OIcff">
                            <Link className="styles_menuItem__yyh7A" to="/my-account">
                              <img src="https://gcs.buymed.com/thuocsi-live/internal/cms/2024aee7e46390bba5781d7cf6cd5392Icon-1.svg" />
                              <span>Tài khoản của tôi</span>
                            </Link>

                            <Link className="styles_menuItem__yyh7A" to="/my-order">
                              <img src="https://gcs.buymed.com/thuocsi-live/internal/cms/20244180af43ac1ca5e1cdb5df436694Product_Cost-1.svg" />
                              <span>Đơn hàng của tôi</span>
                            </Link>

                            <Link className="styles_menuItem__yyh7A" to="/users/loyalty_points">
                              <img src="https://gcs.buymed.com/thuocsi-live/internal/cms/20249410565fc83ff432dea126f4fda8dtl_non.svg" />
                              <span>Điểm tích lũy</span>
                            </Link>

                            <Link className="styles_menuItem__yyh7A" to="/users/my-ticket">
                              <img src="https://gcs.buymed.com/thuocsi-live/internal/cms/20240c5f136a9b1b9692d7e21927ba73phan_hoi_non_ac.svg" />
                              <span>Phản hồi của tôi</span>
                            </Link>

                            <Link className="styles_menuItem__yyh7A" to="/users/rewards">
                              <img src="https://gcs.buymed.com/thuocsi-live/internal/cms/2024fcf7f1a1b808d3f8c39c9e5a8502ct_tt_non.svg" />
                              <span>Chương trình trả thưởng</span>
                            </Link>

                            <button
                              className="MuiButtonBase-root styles_menuItem__yyh7A"
                              type="button"
                              onClick={() => {
                                localStorage.removeItem("token")
                                localStorage.removeItem("user")
                                window.location.href = `/`;
                              }}
                            >
                              <img src="https://gcs.buymed.com/thuocsi-live/internal/cms/2024da9fe07660ac55f017addf3fb57dFrame-3.svg" />
                              <span>Đăng xuất</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </div >

      <div className="styles_login_wrapper__iYXLC show-1199">
        <div className="styles_login__W23q6 styles_logged__TkZaj">

          {/* LEFT */}
          <div className="styles_lSection__YKbuK">
            <div
              className="MuiBox-root css-70qvj9"
              aria-label="menu"
            >
              <span onClick={onOpenMenu} className="img-wrapper">
                <img
                  src="https://cdn-web-mobile-next.thuocsi.vn/images/header-v2/hamburger_icon.svg"
                  alt="menu"
                />
              </span>
            </div>
          </div>

          {/* SEARCH */}
          <div className="styles_search__92K3d">
            <Link
              className="styles_boxSearch__kjrNB"
              to="/quick-order"
            >
              <span className="img-wrapper">
                <img
                  src="https://cdn-web-mobile-next.thuocsi.vn/images/header-v2/header_search_icon.svg"
                  alt="search"
                />
              </span>
              <p className="styles_textWrapper__qH2VM">
                Bạn tìm gì hôm nay?
              </p>
            </Link>
          </div>

          {/* RIGHT */}
          <div className="styles_rSection__PKieW">

            {/* Notification */}
            <Link
              className="styles_mobile_rootBase__8z7PQ"
              to="/notifications"
            >
              <button
                className="MuiButtonBase-root MuiIconButton-root styles_notiIcon__TQLUd"
                type="button"
                aria-label="notification"
              >
                <span className="MuiIconButton-label">
                  <span className="MuiBadge-root styles_badgeCart__6T_ZI">
                    <img
                      src="https://cdn-web-mobile-next.thuocsi.vn/images/header-v2/notification_filled.svg"
                      alt="notification"
                    />
                    <span className="MuiBadge-badge MuiBadge-anchorOriginTopRightRectangular MuiBadge-invisible">
                      0
                    </span>
                  </span>
                </span>
                <span className="MuiTouchRipple-root" />
              </button>
            </Link>

            {/* Cart */}
            <Link
              className="styles_mobile_rootBase__8z7PQ cart_count"
              to="/cart"
            >
              <button
                className="MuiButtonBase-root MuiIconButton-root styles_notiIcon__TQLUd"
                type="button"
                aria-label="cart"
              >
                <span className="MuiIconButton-label">
                  <span className="MuiBadge-root styles_badgeCart__6T_ZI">
                    <img
                      src="https://cdn-web-mobile-next.thuocsi.vn/images/header-v2/cart_filled.svg"
                      alt="cart"
                    />
                    <span className="MuiBadge-badge MuiBadge-anchorOriginTopRightRectangular">
                      {totalItems}
                    </span>
                  </span>
                </span>
                <span className="MuiTouchRipple-root" />
              </button>
            </Link>

          </div>
        </div>
      </div>
    </>
  )
}
